module.exports = __webpack_public_path__ + "img/melody.12a7d640.svg";